// extracted by mini-css-extract-plugin
export default {"main":"_72db512779","tit":"_9019354f1e","maintitle":"e496e9b5c1","ylw":"_0f816790f5","white":"_3a7c74f800","mv_title":"_51cbf7a6ed","mv_nc":"_479129db75","mv_in":"ef451f7757"};